import { PATERNITY_STUDIES_ACTIONS } from 'constants/Actions/PaternityStudies';

// Estado inicial del reducer
const aInitialState = {
    // Manejo de la lista de estudios de paternidad
    aPaternityStudies: [],
    // Manejo de la lista de estudios de paternidad en bandeja de entrada
    aPaternityStudiesInbox: [],
    // Manejo de la lista de estudios de paternidad en bandeja de salida
    aPaternityStudiesOutbox: [],
    // Manejo del total de páginas para el listado de estudios de paternidad
    nTotalPages: 0,
    // Manejo del total de páginas para el listado de estudios de paternidad en bandeja de entrada
    nTotalPagesInbox: 0,
    // Manejo del total de páginas para el listado de estudios de paternidad en bandeja de salida
    nTotalPagesOutbox: 0,
    // Manejo del estudio de paternidad al ver su detalle
    oPaternityStudy: null,
    aIndividuals: [],
    aSamples: [],
    aAttachments: [],
    // Manejo de la traza de un estudio de paternidad al ver su detalle
    aTraceabilities: [],
    // Manejo de errores y acciones satifactorias
    bIsError: false,
    bIsSuccess: false,
    // Manejo de una nueva inserción
    nNewId: null,
    // Manejo de los tipos de estudio de paternidad
    aTypes: [],
    // Manejo de la toma de una ficha de estudio de paternidad
    sFile: null,
    // Manejo de la toma del calculo de paternidad
    sFileCalculate: null,
    // Manejo de registros que serán ingresados mediante una planilla
    bImportSuccess: false,
    aDataImport: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los estudios de patarnidad del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const PaternityStudiesReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case PATERNITY_STUDIES_ACTIONS.GET:
            return { ...aState, aPaternityStudies: oAction.data.data, nTotalPages: oAction.data.pages };
        case PATERNITY_STUDIES_ACTIONS.GET_INBOX:
            return { ...aState, aPaternityStudiesInbox: oAction.data.data, nTotalPagesInbox: oAction.data.pages };
        case PATERNITY_STUDIES_ACTIONS.GET_OUTBOX:
            return { ...aState, aPaternityStudiesOutbox: oAction.data.data, nTotalPagesOutbox: oAction.data.pages };
        case PATERNITY_STUDIES_ACTIONS.GET_SHEET:
            return { ...aState, sFile: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.GET_CALCULATION:
            return { ...aState, sFileCalculate: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.FIND:
            return { ...aState, oPaternityStudy: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.FIND_INDIVIDUALS:
            return { ...aState, aIndividuals: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.FIND_SAMPLES:
            return { ...aState, aSamples: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.FIND_ATTACHMENTS:
            return { ...aState, aAttachments: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.TRACEABILITY:
            return { ...aState, aTraceabilities: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.UPDATE:
            return { ...aState, bIsSuccess: true };
        case PATERNITY_STUDIES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case PATERNITY_STUDIES_ACTIONS.GET_TYPES:
            return { ...aState, aTypes: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.SUCCESS_UPLOAD_FILE:
            return { ...aState, bImportSuccess: true, aDataImport: oAction.data };
        case PATERNITY_STUDIES_ACTIONS.RESET:
            return { ...aState, bIsError: false, bIsSuccess: false, nNewId: null };
        case PATERNITY_STUDIES_ACTIONS.CLEAN:
            return { ...aState, bIsError: false, bIsSuccess: false, nNewId: null, oPaternityStudy: null, aIndividuals: [], aSamples: [], aAttachments: [], aTraceabilities: [], sFile: null };
        case PATERNITY_STUDIES_ACTIONS.CLEAN_IMPORTS:
            return { ...aState, bImportSuccess: false, aDataImport: [] };
        case PATERNITY_STUDIES_ACTIONS.CLEAN_CALCULATION:
            return { ...aState, sFileCalculate: null };
        default:
            return aState;
    }
}
